import { render, staticRenderFns } from "./WidgetFaqPremiumMembership.vue?vue&type=template&id=84aa96e4"
import script from "./WidgetFaqPremiumMembership.vue?vue&type=script&lang=js"
export * from "./WidgetFaqPremiumMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports